import { createElement } from 'react';
import { Helmet } from 'react-helmet';

interface IProps {
  shouldSetDeviceWidth: boolean;
}

// FIXME:
// src/index.html のwidth が1024 で固定されているため、Latest Insights ページでのみviewport を上書きしている
// page コンポーネントでHelmet をrender しても、unmount 時にwidth が元に戻らないため、viewport を上書きするためだけのコンポーネントを作成してRoot で読み込んでいる
// レスポンシブ対応の方針が決まり次第このコンポーネントは削除されるべき
const OverrideViewport: React.FC<IProps> = (props) => {
  const width = props.shouldSetDeviceWidth ? 'device-width' : '1024';
  const content = `width=${width},initial-scale=1`;

  return (
    <Helmet>
      <meta name="viewport" content={content} />
    </Helmet>
  );
};

export default OverrideViewport;
